import { useEffect, useRef, useState } from 'react'
import fastDb from './DB/fast.json'
import { numeroAleatorio } from './Logic/numeroAleatorio'
import './prueba.css'
import { SvgModosJuego, SvgEstadisticas, SvgWhatsApp, SvgPlay, SvgDownload, SvgLink, SvgGithub, SvgHome } from './Images/svgs'
import db from './DB/db.json'
import { barraLateral, fondoJuego, formulario, juego, modosJuegos, ventEstadist, ventFinal } from './Styles/estilos'
import { ModoTarget } from './Componentes/ModoTarget'
import { ModoContainer } from './Componentes/ModoContenedor'

const quitarTildes = (text) => {
  let newText = ''

  for (let i = 0; i < text.length; i++) {
    if (text[i] === 'á') newText += 'a'
    else if (text[i] === 'é') newText += 'e'
    else if (text[i] === 'í') newText += 'i'
    else if (text[i] === 'ó') newText += 'o'
    else if (text[i] === 'ú') newText += 'u'
    else newText += text[i]
  }

  return newText
}

const redondear = (numero, decimales) => {
  const fact = Math.pow(10, decimales)
  return Math.round(numero * fact) / fact
}

export function App () {
  const inputRef = useRef(null)

  const [path, setPath] = useState('')
  const [showPath, setShowPath] = useState('')
  const [pathSpan, setPathSpan] = useState('')
  const [incorrect, setIncorrect] = useState(false)
  const [errorGuardado, setErrorGuardado] = useState(0)

  const [jugando, setJugando] = useState(false)
  const [progreso, setProgreso] = useState(-1)
  const [finalizar, setFinalizar] = useState(0)
  const [ventanaModoAbierta, setEventanaModoAbierta] = useState(false)
  const [ventanaEstadisAbierta, setVentanaEstadisAbierta] = useState(false)

  // Tipos de juegos
  const [includTildes, setIncludTildes] = useState(false)

  const [slm, setSlm] = useState(false)
  const [slmm, setSlmm] = useState(false)
  const [slnc, setSlnc] = useState(false)
  const [slt, setSlt] = useState(false)

  const [lsm, setLsm] = useState(false)
  const [lsmm, setLsmm] = useState(false)
  const [lsnc, setLsnc] = useState(false)
  const [lst, setLst] = useState(false)

  const [lsnnc, setLsnnc] = useState(false)
  const [lsnnm, setLsnnm] = useState(false)
  const [lsnng, setLsnng] = useState(false)
  const [lsnt, setLsnt] = useState(false)

  const [tiempo, setTiempo] = useState(0)
  const [final, setFinal] = useState(false)
  const [listo, setListo] = useState(false)

  // Estadisticas get del local storage
  const [estadistLetrasMinut, setEstadistLetrasMinut] = useState(+window.localStorage.getItem('stdLPM'))
  const [estadistLetras, setEstadistLetras] = useState(+window.localStorage.getItem('stdL'))
  const [estadistPunt, setEstadistPunt] = useState(+window.localStorage.getItem('stdP'))

  // Responsive
  const [ocultaBarraLateral, setOcultaBarraLateral] = useState(false)

  // Actualizar las estadisticas
  const actualizarEstadisticas = () => {
    setEstadistLetrasMinut(+window.localStorage.getItem('stdLPM'))
    setEstadistLetras(+window.localStorage.getItem('stdL'))
    setEstadistPunt(+window.localStorage.getItem('stdP'))
  }

  // Cronometro
  useEffect(() => {
    if (jugando) {
      const interval = setInterval(() => { setTiempo(tiempo + 100) }, 100)
      return () => clearInterval(interval)
    } else if (!final) {
      setTiempo(0)
    }
  }, [tiempo, jugando, final])

  // Iniciar el juego
  useEffect(() => {
    const modos = [
      {
        titulo: ' slm ',
        propiedad: slm,
        texts: db.slm
      },
      {
        titulo: ' slmm ',
        propiedad: slmm,
        texts: db.slmm
      },
      {
        titulo: ' slnc ',
        propiedad: slnc,
        texts: db.slnc
      },
      {
        titulo: ' slt ',
        propiedad: slt,
        texts: db.slt
      },
      {
        titulo: ' lsm ',
        propiedad: lsm,
        texts: db.lsm
      },
      {
        titulo: ' lsmm ',
        propiedad: lsmm,
        texts: db.lsmm
      },
      {
        titulo: ' lsnc ',
        propiedad: lsnc,
        texts: db.lsnc
      },
      {
        titulo: ' lst ',
        propiedad: lst,
        texts: db.lst
      },
      {
        titulo: ' lsnnc ',
        propiedad: lsnnc,
        texts: db.lsnnc
      },
      {
        titulo: ' lsnnm ',
        propiedad: lsnnm,
        texts: db.lsnnm
      },
      {
        titulo: ' lsnng ',
        propiedad: lsnng,
        texts: db.lsnng
      },
      {
        titulo: ' lsnt ',
        propiedad: lsnt,
        texts: db.lsnt
      }
    ]

    function iniciarJuego () {
      setPathSpan('')
      setEventanaModoAbierta(false)
      setProgreso(0)
      setFinalizar(path.length)
      setJugando(true)
      inputRef.current.focus()
    }
    // TODO: Completar el db

    // Elegir el string a jugar en dependencia del modo
    let nuevaRuta = ''
    modos.forEach((modo) => {
      if (modo.propiedad) {
        nuevaRuta = !includTildes ? modo.texts[numeroAleatorio(0, modo.texts.length)].text : quitarTildes(modo.texts[numeroAleatorio(0, modo.texts.length)].text)

        setListo(true)
        setPathSpan('')
        setEventanaModoAbierta(false)
        setFinalizar(path.length)
        setErrorGuardado(0)

        // iniciarJuego()
        setPath(nuevaRuta)
        setShowPath(path)
      }
    })
  }, [path, includTildes, slm, slmm, slnc, slt, lsm, lsmm, lsnc, lst, lsnnc, lsnnm, lsnng, lsnt])

  // Actualizar el progreso y ponerlo en rojo
  useEffect(() => {
    setProgreso(pathSpan.length)
  }, [pathSpan])

  // Cuando termine el juego
  useEffect(() => {
    if (progreso === finalizar && progreso > 0) {
      console.log('progreso')
      setJugando(false)
      setListo(false)
      setFinal(true)
      setProgreso(0)
      actualizarEstadisticas()

      if (estadistLetrasMinut) {
        const newStdLPM = redondear(((pathSpan.length / (tiempo / 1000)) * 60 + estadistLetrasMinut) / 2, 1)
        const newStdL = pathSpan.length + estadistLetras
        const newStdP = redondear((((pathSpan.length / (tiempo / 1000)) * 60 / 480) * 10 + estadistPunt) / 2, 1)

        window.localStorage.setItem('stdLPM', newStdLPM)
        window.localStorage.setItem('stdL', newStdL)
        window.localStorage.setItem('stdP', newStdP)

        console.log((((pathSpan.length / (tiempo / 1000)) * 60 / 480) * 10 + estadistPunt) / 2)
        console.log()
      } else {
        const newStdLPM = redondear((pathSpan.length / (tiempo / 1000)) * 60, 1)
        const newStdL = pathSpan.length
        const newStdP = redondear(((pathSpan.length / (tiempo / 1000)) * 60 / 480) * 10, 1)

        window.localStorage.setItem('stdLPM', newStdLPM)
        window.localStorage.setItem('stdL', newStdL)
        window.localStorage.setItem('stdP', newStdP)

        console.log('no hay')
      }
      // TODO: Hacer la logica de cuando se finaliza
    }
  }, [progreso, finalizar, pathSpan, tiempo, estadistLetrasMinut, estadistLetras, estadistPunt])

  // Cunado cambie el input
  const handleChange = () => {
    if (inputRef.current) {
      // Separar lo completado de lo incompletado
      const valor = inputRef.current.value
      const valorLenght = valor.length

      if (valor[valorLenght - 1] === path[valorLenght - 1] && !incorrect) {
        let newPath = ''
        let newPathSpan = ''

        for (let i = 0; i < path.length; i++) {
          if (path[i] !== valor[i]) {
            newPath += path[i]
            continue
          }

          newPathSpan += path[i]
        }

        setPathSpan(newPathSpan)
        setShowPath(newPath)
        return
      }

      // Obligar a que si comete un error vire hacia atras
      if (valor[valorLenght - 1] === path[valorLenght - 1] && incorrect && valorLenght === errorGuardado - 1) {
        setErrorGuardado(0)
        setIncorrect(false)
        return
      }

      if (errorGuardado === 0) {
        setErrorGuardado(valorLenght)
      }
      if (errorGuardado !== 0 && valor === path.slice(0, valorLenght)) {
        console.log('Tramposo') // TODO: Hacer la logica de cuando la persona cambia el texto sin virar hacia atras haciendo trampa
      }
      setIncorrect(true)
    }
  }

  // Inicia el juego y el cronometro
  function iniciarJuego () {
    setProgreso(0)
    setJugando(true)
    // inputRef.current.focus()
  }

  // Cuando es enfocado el input
  const focusInput = () => {
    if (listo) {
      iniciarJuego()
    }
  }

  const handleClickHome = () => {
    setVentanaEstadisAbierta(false)
    setListo(false)
    setFinal(false)
    setEventanaModoAbierta(false)
    setJugando(false)
    restablecerModos()
  }

  // Click en boton 'Modos'
  const handleClickModos = () => {
    setVentanaEstadisAbierta(false)
    setListo(false)
    setFinal(false)
    setEventanaModoAbierta(!ventanaModoAbierta)
    setJugando(false)
    restablecerModos()
  }

  // Click en boton 'Estadisticas'
  const handleClickEstadist = () => {
    actualizarEstadisticas()
    setVentanaEstadisAbierta(!ventanaEstadisAbierta)
    setFinal(false)
    setListo(false)
    setJugando(false)
    setEventanaModoAbierta(false)
    restablecerModos()
  }

  // Borrar estadisticas
  const handleClickReiniciarEstadist = () => {
    window.localStorage.removeItem('stdLPM')
    window.localStorage.removeItem('stdL')
    window.localStorage.removeItem('stdP')
    actualizarEstadisticas()
  }
  // Si se deja de jugar restablece todos los modos a false
  useEffect(() => {
    if (!jugando) {
      setSlm(false)
      setSlmm(false)
      setSlnc(false)
      setSlt(false)
      setLsm(false)
      setLsmm(false)
      setLsnc(false)
      setLst(false)
      setLsnnc(false)
      setLsnnm(false)
      setLsnng(false)
      setLsnt(false)
      inputRef.current.value = ''
    }
  }, [jugando])

  const restablecerModos = () => {
    setSlm(false)
    setSlmm(false)
    setSlnc(false)
    setSlt(false)
    setLsm(false)
    setLsmm(false)
    setLsnc(false)
    setLst(false)
    setLsnnc(false)
    setLsnnm(false)
    setLsnng(false)
    setLsnt(false)
    inputRef.current.value = ''
  }
  return (

    <div className='flex h-screen'>
      <section className={!listo && !jugando && !final && !ventanaModoAbierta && !ventanaEstadisAbierta ? barraLateral.normal : barraLateral.jugando}>

        <div className='border-b-2 pb-2'>
          <h1 className='text-center text-3xl font-extrabold bg-[#282828] rounded-full text-orange-400 p-1.5 bordaer-2 baorder-[#454545] t'>PortFolio Type</h1>
        </div>
        <div className='flex flex-col gap-4 mt-4'>
          <div className='flex flex-col gap-2'>
            <button className='rounded-full bg-[#272727] p-2 flex justify-center gap-1.5 hover:bg-[#313131]' onClick={() => setSlm(true)}><SvgPlay/> Jugar ya</button>
            <button className='rounded-full bg-[#272727] p-2 flex justify-center gap-1.5 hover:bg-[#313131]' onClick={handleClickModos}><SvgModosJuego/> Modos</button>
            <button className='rounded-full bg-[#272727] p-2 flex justify-center gap-1.5 hover:bg-[#313131]' onClick={handleClickEstadist}><SvgEstadisticas/> Mis estadisticas</button>
            <a className='rounded-full bg-[#272727] p-2 flex justify-center gap-1.5 hover:bg-[#313131]' href='https://api.whatsapp.com/send/?text=Te+reto+a+escribir+más+rápido+que+yo:+https%3A%2F%2Fmeka.pages.dev%2Fcourses%c++&type=custom_url&app_absent=0'><SvgWhatsApp/> Invitar amigo a jugar</a>

          </div>

          <div className='flex flex-col gap-2'>
            <a className='rounded-full bg-[#272727] p-2 flex justify-center gap-1.5 hover:bg-[#313131]' href='https://github.com/YarielZC'><SvgGithub/>Github</a>
            <a className='rounded-full bg-[#272727] p-2 flex justify-center gap-1.5 hover:bg-[#313131]' href='/'><SvgLink/> Visitar PortFolio</a>
            <a className='rounded-full bg-[#272727] p-2 flex justify-center gap-1.5 hover:bg-[#313131]' href='/'><SvgDownload/> Descargar para PC</a>

          </div>
        </div>

        <a className='text-sm text-white/65 text-center font-semibold' href='/'>Pagina creada para el PortFolio de <br/>Yariel Zamora del Cueto</a>
      </section>

      <section className={listo || final || ventanaModoAbierta || ventanaEstadisAbierta ? juego.jugando : juego.normal}>
        <div className='h-full absolute w-full bg-cover bg-center bg-no-repeat blur-[9px] bg-[url(./Images/Fondo.webp)] -z-20'></div>
        <div className={listo ? fondoJuego.jugando : fondoJuego.normal}></div>
        <div className='absolute flex h-full items-end'>
          <div className='p-6 py-8'>

            <button onClick={handleClickHome} className='bg-blue-500 p-3 rounded-full z-40 2xl:opacity-65 hover:opacity-100 transition-all ease-in-out duration-300'><SvgHome/></button>
          </div>

        </div>

        <div className={listo ? formulario.jugando : formulario.normal}>

          <p className='w-4/5 -mb-6 text-red-600 font-bold'>{progreso}/{finalizar}</p>
          <p className='select-none w-4/5 text-justify text-white/45'><span className='text-red-600'>{pathSpan}</span>{showPath}</p>

          <div className='flex justify-center w-full'>
            <textarea className='outline-none bg-transparent w-4/5 h-52 resize-none border-2 rounded-xl p-2.5' name="" id=""
            onFocus={focusInput}
            onChange={handleChange}
            ref={inputRef}
            placeholder='Haz click aquí para comenzar...'
            ></textarea>
          </div>

        </div>

        <section className={final ? ventFinal.final : ventFinal.jugando}>
          <h3 className='text-6xl font-bold text-center text-orange-6s00'>Fin del juego</h3>
          <div className='flex flex-col gap-8 justify-center items-center'>
            <div className='flex gap-5'>

              <p className='text-2xl text-orange-5s00 font-extrabold'>Tiempo tardado:<p className='text-center text-3xl mt-2'> {tiempo / 1000} </p></p>

              <p className='text-2xl text-orange-s500 font-extrabold'>Letras por minuto:<p className='text-center text-3xl mt-2'>{redondear((pathSpan.length / (tiempo / 1000)) * 60, 1)}</p></p>

            </div>
              <p className='text-4xl text-orange-500 font-extrabold'>Puntuación:<p className='text-center text-6xl mt-2'>{ redondear(((pathSpan.length / (tiempo / 1000)) * 60 / 480) * 10, 1) }</p></p>
          </div>
        </section>

        <div className={ventanaModoAbierta ? modosJuegos.ventanaAbierta : modosJuegos.jugando}>
          <h3 className='text-2xl font-bold'>Modos de juego</h3>
          <div className='flex items-center gap-1 ml-3'>
              <input className='z-30' onClick={() => setIncludTildes(!includTildes)} type="checkbox" name="" id="" />
              <p className='text-sm font-semibold text-white/65'>Desactivar tildes</p>
            </div>

          <hr className='h-[1px] mt-2 border-white/65'/>
          <div className='flex flex-col gap-1 items-center max-sm:grid max-sm:h-full max-sm:overflow-y-auto'>

            <ModoContainer titulo='Solo letras'>
              <ModoTarget titulo='Minúsculas' dificultad={1} setProp={setSlm} >Solo letras minúsculas, sin ningún tipo de signo.</ModoTarget>
              <ModoTarget titulo='Minúsculas y  Mayúsculas' dificultad={2} setProp={setSlmm}>Letras minúsculas y mayúsculas, sin ningún tipo de signo.</ModoTarget>
              <ModoTarget titulo='Nombre complicados' dificultad={3} setProp={setSlnc}>Letras minúsculas con nombres científicos y de complicada escritura.</ModoTarget>
              <ModoTarget titulo='Todo' dificultad={4} setProp={setSlt}>Letras minúsculas y mayúsculas, nombres complejos, sin signos.</ModoTarget>
            </ModoContainer>

            <ModoContainer titulo='Letras y signos'>
              <ModoTarget titulo='Minúsculas' dificultad={1} setProp={setLsm}>Solo letras minúsculas, con todo tipo de signo.</ModoTarget>
              <ModoTarget titulo='Minúsculas y  Mayúsculas' dificultad={2} setProp={setLsmm}>Letras minúsculas y mayúsculas,  con todo tipo de signo.</ModoTarget>
              <ModoTarget titulo='Nombre complicados' dificultad={4} setProp={setLsnc}>Letras minúsculas con nombres científicos y de complicada escritura  con todo tipo de signo..</ModoTarget>
              <ModoTarget titulo='Todo' dificultad={5} setProp={setLst}>Letras minúsculas y mayúsculas, nombres complejos,  con todo tipo de signo.</ModoTarget>
            </ModoContainer>

            <ModoContainer titulo='Letras, signos y numeros'>
              <ModoTarget titulo='Números cortos' dificultad={2} setProp={setLsnnc}>Letras minúsculas y mayúsculas, con todo tipo de signo y numeros cortos.</ModoTarget>
              <ModoTarget titulo='Numeros medianos' dificultad={2} setProp={setLsnnm}>Letras minúsculas y mayúsculas, con todo tipo de signo y numeros medianamente grandes.</ModoTarget>
              <ModoTarget titulo='Numeros grandes' dificultad={4} setProp={setLsnng}>Letras minúsculas y mayúsculas con nombres científicos y numeros grandes con todo tipo de signo.</ModoTarget>
              <ModoTarget titulo='Todo' dificultad={5} setProp={setLsnt}>Letras minúsculas y mayúsculas con nombres científicos y numeros gigantes con todo tipo de signo.</ModoTarget>
            </ModoContainer>

          </div>
        </div>

        <div className={ventanaEstadisAbierta ? ventEstadist.ventanaAbierta : ventEstadist.normal}>

          <h3 className='p-3.5 text-3xl font-bold absolute border-b-2 w-full'>Tus estadísticas</h3>
          <div className='h-full flex flex-col gap-16 items-center justify-center'>
            <div className='w-full flex flex-col gap-5'>
              <div className='flex gap-4 w-full justify-evenly'>
                <p className='text-center text-2xl font-semibold'>Letras por minuto promedio: <p className='font-bold text-3xl'>{estadistLetrasMinut}</p> </p>
                <p className='text-center text-2xl font-semibold'>Letras escritas: <p className='font-bold text-3xl'>{estadistLetras}</p></p>
                <p className='text-center text-2xl font-semibold'>Puntuación promedio: <p className='font-bold text-3xl'>{estadistPunt}</p></p>
              </div>

            </div>

            <div className='flex justify-end w-10/12 mx-auto'>
              <button className='bg-orange-700 rounded-full py-2 px-3.5 text-lg font-semibold' onClick={handleClickReiniciarEstadist}>Reiniciar estadísticas</button>

            </div>
          </div>

        </div>

      </section>

    </div>
  )
}
